// extracted by mini-css-extract-plugin
export default {"chip":"styles-module__chip__ed17fd717334215955df","active":"styles-module__active__e0e436e5fa7afb52bfe3"};